






























import { computed, defineComponent, getCurrentInstance, PropType } from 'vue';
import AulaAlert from '../AulaAlert.vue';
import { NotificationModel } from '../../models/notification.model';
import Icon from '../Icon.vue';
import { iconClassEnum } from '../../enums/iconClassEnum';
import button from '../../../shared/directives/button.js';
import { useNotificationTypes, useNotificationContent } from '../../../src/composables/notifications';

export default defineComponent({
  name: 'Notification',
  components: { Icon, AulaAlert },
  directives: {
    button,
  },
  props: {
    notification: {
      type: Object as PropType<NotificationModel>,
      required: true,
    },
  },
  emits: ['open', 'delete'],
  setup(props, { emit }) {
    const instance = getCurrentInstance();
    if (!instance) {
      throw new Error('Notification component must be used within Vue instance');
    }

    // Use composables for notification logic
    const notificationTypes = useNotificationTypes(props.notification);
    const notificationContent = useNotificationContent(props.notification);

    const notificationClass = computed(() => ({
      interactable: notificationTypes.canSeeMoreInformation.value,
    }));

    const getText = (key: string, params?: Record<string, any>): string =>
      instance.proxy.$getText(key, params) as string;

    // Event handlers
    const emitOpen = (): void => {
      emit('open');
    };

    const emitDelete = (): void => {
      emit('delete');
    };

    // Return reactive properties and methods for template
    return {
      // Computed from composables
      alertType: notificationTypes.alertType,
      hasDefaultIcon: notificationTypes.hasDefaultIcon,
      isResponseRequired: notificationTypes.isResponseRequired,
      type: notificationContent.type,
      title: notificationContent.title,
      content: notificationContent.content,
      link: notificationContent.link,
      moreInformation: notificationContent.moreInformation,

      // Local computed
      iconClassEnum,
      notificationClass,

      // Methods
      emitOpen,
      emitDelete,
      getText,
    };
  },
});
